<template>
  <aside
    v-if="navigation"
    class="w-56 overflow-y-auto border-r border-gray-200 bg-gray-100 px-3 py-6"
    :class="
      hoveredMainNavigationItem
        ? 'absolute z-[101] left-28 top-16 bottom-0 xl:!static'
        : 'hidden xl:block'
    "
  >
    <nav class="space-y-1" aria-label="Sidebar">
      <template v-for="item in navigation" :key="item">
        <div v-if="item.divideBefore" class="w-full border-t border-gray-300" />
        <RolloutLink
          v-slot="{ isActive }"
          :navigation-item="item"
          :global="isGlobal"
         
          active-class="bg-indigo-100 text-indigo-900"
          inactive-class="text-gray-600 hover:bg-gray-50 hover:text-gray-900"
          :exact="item.renderExact"
          class="group flex items-center rounded-md px-3 py-2 text-sm font-medium"
          aria-current="page"
        >
          <span class="truncate">{{ $t('navigation.' + item.name) }}</span>
          <span
            v-if="item.count"
            :class="[
              isActive
                ? 'bg-indigo-500 text-white'
                : 'bg-gray-200 text-gray-600',
              'ml-auto inline-block rounded-full px-3 py-0.5 text-xs',
            ]"
          >
            {{ item.count }}
          </span>
        </RolloutLink>
      </template>
    </nav>
  </aside>
</template>

<script lang="ts" setup>
import { useUiStore } from '~/stores/ui';
import { useUserStore } from '~/stores/user';
import { isNavItemAccessible } from '~/util/navigation';

const { selectedRollout, subNavigation, currentItems } = useRolloutRouting();

const isGlobal = computed(() => currentItems.value.mainNavigationItem?.global);

const userStore = useUserStore();
const uiStore = useUiStore();

const hoveredMainNavigationItem = computed(
  () => uiStore.hoveredMainNavigationItem
);

const navigation = computed(
  () =>
    uiStore.hoveredMainNavigationItem?.subNavigation?.filter((item) => {
      return isNavItemAccessible(
        item,
        selectedRollout.value,
        userStore.user?.role
      );
    }) ?? subNavigation.value
);
</script>
